import { Link } from 'react-router-dom';
import './legalPage.css';

export default function EulaPage() {
  return (
    <div className="legalPageDiv">
      <div className="legalPageHeader">
        <Link to="/" className="backToHomeLink">← Back to Home</Link>
        <h1 className="legalPageTitle">End-User License Agreement</h1>
        <p className="legalPageDate">Last updated: April 25, 2026</p>
      </div>

      <div className="legalPageBody">
        <p>
          This End-User License Agreement ("Agreement") is a legal agreement between you ("User")
          and Effectual Tools ("Company", "we", "us", or "our") governing your use of the
          Effectual Tools scheduling and care management application ("Application").
          By accessing or using the Application, you agree to be bound by this Agreement.
          If you do not agree, do not use the Application.
        </p>

        <h2>1. License Grant</h2>
        <p>
          Subject to the terms of this Agreement, the Company grants you a limited,
          non-exclusive, non-transferable, revocable license to access and use the
          Application solely for your organization's internal care scheduling and
          management purposes.
        </p>

        <h2>2. Restrictions</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Copy, modify, or distribute the Application or its content;</li>
          <li>Reverse engineer, decompile, or disassemble the Application;</li>
          <li>Use the Application for any unlawful purpose or in violation of any regulations;</li>
          <li>Share login credentials or allow unauthorized access to the Application;</li>
          <li>Transmit any harmful, offensive, or disruptive content through the Application;</li>
          <li>Use the Application to store or transmit protected health information beyond the scope
            of your authorized use.</li>
        </ul>

        <h2>3. Ownership</h2>
        <p>
          The Application and all intellectual property rights therein are and shall remain the
          exclusive property of Effectual Tools. This Agreement does not grant you any rights to
          trademarks, service marks, or trade names of the Company.
        </p>

        <h2>4. User Data</h2>
        <p>
          You retain ownership of all data you input into the Application, including client
          information, shift records, and care reports. By using the Application, you grant
          the Company a limited license to store and process this data solely to provide the
          service to you. See our <Link to="/privacy-policy" className="legalLink">Privacy Policy</Link> for
          details on how data is handled.
        </p>

        <h2>5. Confidentiality</h2>
        <p>
          The Application may contain sensitive client and caretaker information. You are
          responsible for maintaining the confidentiality of all information accessed through
          the Application and for ensuring that only authorized personnel have access to
          client records and care data.
        </p>

        <h2>6. Termination</h2>
        <p>
          This Agreement is effective until terminated. The Company may terminate your access
          at any time for violation of this Agreement or for any other reason with notice.
          Upon termination, you must cease all use of the Application.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          THE APPLICATION IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR
          A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. THE COMPANY DOES NOT WARRANT THAT
          THE APPLICATION WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF HARMFUL COMPONENTS.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY
          BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
          ARISING OUT OF OR RELATED TO YOUR USE OF THE APPLICATION, EVEN IF ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES. THE COMPANY'S TOTAL LIABILITY SHALL NOT EXCEED THE
          AMOUNTS PAID BY YOU FOR THE APPLICATION IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          This Agreement shall be governed by and construed in accordance with the laws of
          the State of Arizona, without regard to its conflict of law provisions.
        </p>

        <h2>10. Changes to This Agreement</h2>
        <p>
          We reserve the right to modify this Agreement at any time. We will notify you of
          material changes by updating the "Last updated" date above. Continued use of the
          Application after changes constitutes acceptance of the revised Agreement.
        </p>

        <h2>11. Contact</h2>
        <p>
          For questions about this Agreement, contact us at:{' '}
          <a href="mailto:daniel@effectual.tools" className="legalLink">daniel@effectual.tools</a>
        </p>
      </div>
    </div>
  );
}
